import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { StorePage } from '@/features/resources/store-page';

const searchSchema = z.object({
  tab: z.enum(['stock', 'movements', 'counts']).optional().catch(undefined),
  item: z.string().optional().catch(undefined),
  movement: z.string().optional().catch(undefined),
  count: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/resources/store')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <StorePage
      projectId={projectId}
      tab={search.tab}
      itemId={search.item}
      movementId={search.movement}
      countId={search.count}
    />
  );
}
